import type { ValidateReturnRequestLineItemsBodyDto } from "../generated/schema.ts";
import { useInvalidateReturnRequest } from "./use-invalidate-return-request.ts";
import { useApiMutation } from "./use-api-mutation";

interface UseValidateReturnRequestLineItemsParams {
	onSuccess?: () => void;
	onError?: () => void;
	onMutate?: () => void;
}

export default function useValidateReturnRequestLineItems(
	params?: UseValidateReturnRequestLineItemsParams,
) {
	const invalidateReturnRequest = useInvalidateReturnRequest();

	return useApiMutation(
		"post",
		"/shops/{shopId}/return-requests/{returnRequestId}/line-items/validate",
		{
			onMutate: params?.onMutate,
			onSuccess(_, variables) {
				invalidateReturnRequest({
					shopId: (variables as {
				shopId: string;
				returnRequestId: string;
				requestBody: ValidateReturnRequestLineItemsBodyDto;
			}).shopId,
					returnRequestId: (variables as {
				shopId: string;
				returnRequestId: string;
				requestBody: ValidateReturnRequestLineItemsBodyDto;
			}).returnRequestId,
				});
				params?.onSuccess?.();
			},
			onError() {
				params?.onError?.();
			},
			mapVariables: (variables: {
				shopId: string;
				returnRequestId: string;
				requestBody: ValidateReturnRequestLineItemsBodyDto;
			}) => ({
				params: {
					path: {
						shopId: variables.shopId,
						returnRequestId: variables.returnRequestId,
					},
				},
				body: variables.requestBody,
			}),
		},
	);
}
